import { useTheme } from '@mui/material/styles';
import uhLogo from '../../../../assets/images/users/uh-logo.svg'; // adjust the path as needed

export default function LogoIcon() {
  return <img src={uhLogo} alt="UH Logo" width={90} />;
}
